module.exports = __webpack_public_path__ + "img/lifecycle.0f54e156.jpg";